import React from 'react';
import GoogleMapReact from 'google-map-react';
import mapIcon from '../../../../Res/mapIcon.png';

const MarkerReactComponent = ({ text }) => (
  <img
    style={{
      width: '40px',
      color: 'white',
      background: 'grey',
      padding: '5px 5px',
      display: 'inline-flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '100%',
      transform: 'translate(-50%, -50%)',
    }}
    alt={text}
    src={mapIcon}
  />
);

const EdgeDeviceLocator = props => {
  const { coordinates } = props;
  const latLng = coordinates.trim().split(',');
  const lat = parseFloat(latLng[0].trim(), 10);
  const lng = parseFloat(latLng[1].trim(), 10);

  const defaultProps = {
    center: {
      lat,
      lng,
    },
    zoom: 8,
  };

  return (
    <div style={{ height: '55vh', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_EPIK_MAP }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
      >
        <MarkerReactComponent lat={lat} lng={lng} text="" />
      </GoogleMapReact>
    </div>
  );
};

export default EdgeDeviceLocator;
